import { render, staticRenderFns } from "./UserExtInfo.vue?vue&type=template&id=17395118"
import script from "./UserExtInfo.vue?vue&type=script&lang=js"
export * from "./UserExtInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports